var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', {
    staticClass: "tag_list_item"
  }, [_c('a', {
    staticClass: "tag_box",
    attrs: {
      "href": _vm.link,
      "target": "_blank",
      "title": "새창열림"
    }
  }, [_c('span', {
    staticClass: "tag_text"
  }, [_vm._v(_vm._s(_vm.name))])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }